class skfIf {
  attr: string;
  exp: any;
  comment: any;
  rel: any;
  isRemove = false;
  $value: any;

  constructor(private elem, private field: any) {
    this.attr = this.elem.getAttribute("skf-if");
    if (/\$value/.test(this.attr)) {
      const optionIndex = parseInt(this.elem.getAttribute("skf-options"), 10);
      this.$value = this.field.listOptions[optionIndex];
    }
    this.exp = new Function(
      "const $field = this.field; const $value = this.$value; return " +
        this.attr
    );
    this.comment = document.createComment(`sk:if ${this.attr}`);
    this.elem.parentNode.insertBefore(this.comment, this.elem);
    this.rel = this.elem.cloneNode(true);
  }

  update(): void {
    const value = this.exp.call(this);
    if (value) {
      if (!this.elem) {
        this.elem = this.rel.cloneNode(true);
      }
      this.comment.parentNode.insertBefore(this.elem, this.comment);
      this.isRemove = false;
    } else {
      if (!this.isRemove) {
        this.comment.parentNode.removeChild(this.elem);
        this.isRemove = true;
      }
    }
  }
}

export { skfIf };
